import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import Appbar from "../../Component/NavPannel/Appbar";
import UserStatusLayout from "../../Component/Layouts/UserStatusLayout";

const mdTheme = createTheme();

function UserStatus() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Investor Management" />
        <UserStatusLayout />
      </Box>
    </ThemeProvider>
  );
}

export default function UserStatusManagement() {
  return <UserStatus />;
}
